import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { isPlatform, useIonModal } from '@ionic/react'

import { UnlockChatModal } from '@/components/organisms/UnlockChat/UnlockChatModal'

import { UserInfo } from '@/services/user'

export const useUnlockChatModal = ({
  userInfo,
  amount,
}: {
  userInfo: UserInfo
  amount: number
}) => {
  const history = useHistory()
  const isDesktop = isPlatform('desktop')

  const [present, dismiss] = useIonModal(UnlockChatModal, {
    history,
    dismissModal: () => dismiss(),
    userInfo,
    amount,
  })

  const presentUnlockChatModal = useCallback(
    () =>
      present({
        cssClass: 'unlock-chat-modal',
        initialBreakpoint: isDesktop ? undefined : 1,
        breakpoints: isDesktop ? undefined : [0, 1],
      }),
    [isDesktop, present]
  )

  return {
    presentUnlockChatModal,
    dismissUnlockChatModal: dismiss,
  }
}
